/**
 * Minimal Universal Router ABI — execute function only.
 *
 * Story 5.3 Task 1.2
 */

export const universalRouterAbi = [
	{
		type: "function",
		name: "execute",
		stateMutability: "payable",
		inputs: [
			{ name: "commands", type: "bytes" },
			{ name: "inputs", type: "bytes[]" },
			{ name: "deadline", type: "uint256" },
		],
		outputs: [],
	},
] as const;
